import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['5 Tomos PDF completos (Movilidad, Fortalecimiento, Zona Lumbar, Postura y Entrenamiento)', '5 Bonos estratégicos gratis', 'Tabla de progresión de 12 semanas', 'Acceso inmediato', 'Garantía de 7 días'];
const premiumFeatures = ['Todo el Combo Completo Espalda y Columna', '40 rutinas adicionales listas para usar', 'Rutinas de 10, 15, 20, 30 y 45 minutos', 'Calendario semanal detallado por 12 meses', 'Fichas de seguimiento y evaluación trimestral'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo + Mega Kit Espalda 365' : 'Combo Completo Espalda y Columna';
  const subtitle = premium ? '5 Tomos + 5 Bonos + 40 Rutinas Extra' : '5 Tomos + 5 Bonos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$82.990' : '$65.000';
  const savings = premium ? '$55.000' : '$45.000';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-4 border-gold bg-primary text-white shadow-[0_25px_60px_rgba(14,165,233,.35)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border border-sky-100 bg-white shadow-sm'}`} data-id="element-279" data-mp="2oo0u45jynmnf">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 border-amber-200 bg-gold px-4 py-1.5 text-xs font-extrabold text-white shadow-lg" data-id="element-280" data-mp="2to591r5809bj">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-281" data-mp="33ehudlkv06iq" /> MÁS ELEGIDO
        </div>}
      <div className={premium ? 'mt-2' : ''} data-id="element-282" data-mp="3hdzngd56u5xw">
        <div className="flex items-start gap-2" data-id="element-283" data-mp="3hav8ckq6ppsg">
          <span className="text-3xl" data-id="element-284" data-mp="3cewh8pdh1toc">{premium ? '💎' : '📚'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-285" data-mp="2a0fbroon1atc">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-sky-50' : 'text-slate-500'}`} data-id="element-286" data-mp="2ex5u6inx0ihx">
          {subtitle}
        </p>
      </div>

      <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/25 bg-white/10 text-sky-50' : 'border-sky-100 bg-sky-50/70 text-slate-600'}`} data-id="element-287" data-mp="2ns3o9t2su1au">
        <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-288" data-mp="2xo6r715h63yu">Ideal para:</b>{' '}
        {premium ? 'Quienes quieren el programa completo MÁS 40 rutinas extra y un calendario cerrado de 12 meses para no tener que decidir nunca qué hacer ese día.' : 'Personas con dolor de espalda, malas posturas o trabajo sedentario que quieren un programa progresivo, seguro y listo para aplicar en casa o en el gimnasio.'}
      </p>

      <ul className="mb-6 flex-1 space-y-2" data-id="element-289" data-mp="14sw3hpbn74he">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-290" data-mp="102fnbxgft4rc">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-amber-300' : 'text-accent'}`} data-id="element-291" data-mp="v3m922tbt9q4" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6" data-id="element-292" data-mp="1nri3f0vfapjq">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-extrabold ${premium ? 'bg-gold text-white' : 'bg-sky-100 text-accent'}`} data-id="element-293" data-mp="1npnrgc24q7rs">
          AHORRÁS {savings}
        </span>
        <p className={`mt-2 text-sm font-bold line-through ${premium ? 'text-sky-100' : 'text-slate-400'}`} data-id="element-294" data-mp="19siqgqh9vz3e">
          Antes: {before}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-sky-50' : 'text-slate-500'}`} data-id="element-295" data-mp="3dhpg6de4qpy">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-296" data-mp="1m99tnuyigq9j">
          {price}
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth className={premium ? 'border-2 border-amber-100 bg-gold text-xs shadow-[0_0_0_5px_rgba(245,158,11,.28)] hover:bg-amber-600' : 'text-xs'} data-id="element-297" data-mp="1r2cjbs063fkg">
        {premium ? 'QUIERO COMBO + MEGA KIT 365' : 'QUIERO EL COMBO COMPLETO'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-298" data-mp="1w1p8wkifb0qq">
      <div className="text-center" data-id="element-299" data-mp="20x4mdbciqumm">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-300" data-mp="kkfr02ey0grj">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-301" data-mp="pl3qzdl5g7xw">
          Asegurá el precio promocional <span className="text-accent" data-id="element-302" data-mp="d0x079zgjj8e">antes de que suba.</span>
        </h2>
        <div className="mt-6" data-id="element-303" data-mp="d2zn3l5bcw8w">
          <Countdown data-id="element-304" data-mp="r0fvv3b3123t" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-305" data-mp="qzd834923fs4">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '72% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-306" data-mp="3ui6gz3qw3gfy">
                <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-307" data-mp="83eojbu22pwp" />
                {item}
              </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-extrabold text-slate-900 md:text-5xl" data-id="element-308" data-mp="3bqdnl87wrt7p">
        Elegí tu <span className="text-accent" data-id="element-309" data-mp="36sc4woee9vwr">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-310" data-mp="36ppxcori7gej">
        <PlanCard data-id="element-311" data-mp="1ao63l7m08z6l" />
        <PlanCard premium data-id="element-312" data-mp="1aml91hzoxg8q" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-313" data-mp="1fn8wjtopney7">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}